import React, { useContext } from "react";
import { Routes, Route } from "react-router-dom";
import { AuthContext } from "./contexts/AuthContext";
import PrivateRoute from "./components/PrivateRoute";
import MarketingLayout from "./layouts/MarketingLayout";
import DashboardLayout from "./layouts/DashboardLayout";

import Login from "./pages/Login";
import Register from "./pages/Register";
import Settings from "./pages/Settings";
import ForgotPassword from "./pages/ForgotPassword";
import SetPassword from "./pages/SetPassword";
import GoogleAuthCallback from "./pages/GoogleAuthCallback";
import Plans from "./pages/Plans";
import PaymentSettings from "./pages/PaymentSettings";
import Sites from "./pages/Sites";
import SiteEdit from "./pages/SiteEdit";
import SiteOnboarding from "./pages/SiteOnboarding";
import InstallSnippet from "./pages/InstallSnippet";
import StatementEditor from "./pages/StatementEditor";
import PrivacyPolicyEditor from "./pages/PrivacyPolicyEditor";
import AIAssistant from "./pages/AIAssistant";
import Admin from "./pages/Admin";
import AdminInsights from "./pages/AdminInsights";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentFailure from "./pages/PaymentFailure";
import PaymentCancel from "./pages/PaymentCancel";
import PaymentDemo from "./pages/PaymentDemo";
import UsageDashboard from "./pages/UsageDashboard";
import ComplianceCenter from "./pages/ComplianceCenter";
import ComplianceReport from "./pages/ComplianceReport";
import ComplianceDiffReport from "./pages/ComplianceDiffReport";
import DashboardOverview from "./pages/DashboardOverview";

import MarketingHome from "./pages/marketing/MarketingHome";
import MarketingPricing from "./pages/marketing/MarketingPricing";
import MarketingInstallGuide from "./pages/marketing/MarketingInstallGuide";
import MarketingSupport from "./pages/marketing/MarketingSupport";
import MarketingContact from "./pages/marketing/MarketingContact";
import MarketingAbout from "./pages/marketing/MarketingAbout";
import MarketingStandard from "./pages/marketing/MarketingStandard";
import MarketingInfo from "./pages/marketing/MarketingInfo";
import MarketingPartners from "./pages/marketing/MarketingPartners";

export default function App() {
  const { user } = useContext(AuthContext);

  return (
    <Routes>
      {/* Marketing / Public */}
      <Route element={<MarketingLayout />}>
        <Route path="/" element={<MarketingHome />} />
        <Route path="/pricing" element={<MarketingPricing />} />
        <Route path="/install-guide" element={<MarketingInstallGuide />} />
        <Route path="/support" element={<MarketingSupport />} />
        <Route path="/contact" element={<MarketingContact />} />
        <Route path="/about" element={<MarketingAbout />} />
        <Route path="/standard" element={<MarketingStandard />} />
        <Route path="/info" element={<MarketingInfo />} />
        <Route path="/partners" element={<MarketingPartners />} />

        {/* Auth pages stay public but within marketing chrome */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/set-password" element={<SetPassword />} />
        <Route path="/auth/google/callback" element={<GoogleAuthCallback />} />
      </Route>

      {/* Dashboard */}
      <Route element={<DashboardLayout />}>
        <Route
          path="/overview"
          element={
            <PrivateRoute>
              <DashboardOverview />
            </PrivateRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <PrivateRoute>
              <Settings />
            </PrivateRoute>
          }
        />
        <Route
          path="/plans"
          element={
            <PrivateRoute>
              <Plans />
            </PrivateRoute>
          }
        />
        <Route
          path="/payment-settings"
          element={
            <PrivateRoute>
              <PaymentSettings />
            </PrivateRoute>
          }
        />
        <Route
          path="/sites"
          element={
            <PrivateRoute>
              <Sites />
            </PrivateRoute>
          }
        />
        <Route
          path="/sites/:id"
          element={
            <PrivateRoute>
              <SiteEdit />
            </PrivateRoute>
          }
        />
        <Route
          path="/sites/:id/onboarding"
          element={
            <PrivateRoute>
              <SiteOnboarding />
            </PrivateRoute>
          }
        />
        <Route
          path="/sites/:id/install"
          element={
            <PrivateRoute>
              <InstallSnippet />
            </PrivateRoute>
          }
        />
        <Route
          path="/sites/:id/statement"
          element={
            <PrivateRoute>
              <StatementEditor />
            </PrivateRoute>
          }
        />
        <Route
          path="/sites/:id/privacy-policy"
          element={
            <PrivateRoute>
              <PrivacyPolicyEditor />
            </PrivateRoute>
          }
        />
        <Route
          path="/sites/:id/ai"
          element={
            <PrivateRoute>
              <AIAssistant />
            </PrivateRoute>
          }
        />
        <Route
          path="/sites/:id/compliance"
          element={
            <PrivateRoute>
              <ComplianceCenter />
            </PrivateRoute>
          }
        />
        <Route
          path="/sites/:id/compliance-report"
          element={
            <PrivateRoute>
              <ComplianceReport />
            </PrivateRoute>
          }
        />
        <Route
          path="/sites/:id/compliance-diff"
          element={
            <PrivateRoute>
              <ComplianceDiffReport />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <PrivateRoute adminOnly>
              <Admin />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/insights"
          element={
            <PrivateRoute adminOnly>
              <AdminInsights />
            </PrivateRoute>
          }
        />
        <Route
          path="/usage"
          element={
            <PrivateRoute>
              <UsageDashboard />
            </PrivateRoute>
          }
        />

        {/* payment result pages (may be redirected from provider) */}
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/failure" element={<PaymentFailure />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/payment/demo" element={<PaymentDemo />} />

        {/* fallback for authenticated home */}
        <Route path="/app" element={user ? <DashboardOverview /> : <Login />} />
      </Route>
    </Routes>
  );
}


